export default function Loading(){
    return(
        <div className="bg-white w-full h-screen flex justify-center items-center">
            <div className="bg-blue-900 h-20 w-20 animate-spin"/>
        </div>
    )
}